<template>
  <main>
    <div class="slider-area ">
      <div class="single-slider hero-overly slider-height2 d-flex align-items-center"
        v-if="blogtopo != '' && blogtopo[0].insInstitucionalImagens != ''"
        :style="{ backgroundImage: 'url(' + $imgURL + blogtopo[0].insInstitucionalImagens[0].itgUrlImagem + ')', backgroundSize: 'cover', height: '450px' }">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="hero-cap pt-60" style="text-align: center;">
                <h2 style="color:#ffffff;">{{ blogtopo[0].itiNome }}</h2>
                <!--nav aria-label="breadcrumb ">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/" style="color:#000000;">Home</router-link></li>
                    <li class="breadcrumb-item"><a href="#" style="color:#000000;">Treinamentos e Eventos</a></li>
                  </ol>
                </!--nav-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="blog_area section-padding" style="padding-bottom: 20px !important;">
      <v-container>
        <div class="row">
          <div class="col-xl-12">
            <!-- Section Tittle -->
            <div class="section-tittle section-tittle6 mb-50">
              <div class="front-text">
                <h3 class="" style="color:#000000;">Próximos Eventos</h3>
              </div>
            </div>
          </div>
        </div>
        <v-row justify="center">
          <v-col cols="12">
            <v-text-field v-model="searchQuery" label="Pesquisar" outlined clearable></v-text-field>
          </v-col>
        </v-row>
          <v-row justify="left">
            <v-col cols="12" sm="6" md="4" lg="4" v-for="menu in paginatedBlogs" :key="menu.itiId">
              <v-card class="mx-auto" max-width="400">
                    <v-img @click.prevent="OpenModal(menu)" style="cursor: pointer;" class="align-end text-white" height="200" :src="$imgURL + menu.insInstitucionalImagens[0].itgUrlImagem" cover>
                    </v-img>

                    <v-card-subtitle class="pt-4" style="cursor: pointer;" @click.prevent="OpenModal(menu)">
                      Data: {{ formattedDate(menu.itiData1) }}
                    </v-card-subtitle>

                    <v-card-text style="cursor: pointer;" @click.prevent="OpenModal(menu)">
                    <h5>{{ menu.itiNome }}</h5>
                    <div>Horário: {{ menu.itiCampoExtra2 }}</div>
                    <div style="height: 60px;">Local: {{ menu.itiCampoExtra1 }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-pagination
              v-model="page"
              :length="totalPages"
              @input="changePage"
              prev-icon="mdi mdi-chevron-left"
              next-icon="mdi mdi-chevron-right"
            ></v-pagination>
          </v-row>
        </v-container>
        <v-dialog v-model="modalEventos"  max-width="800px" transition="dialog-bottom-transition">
          <v-card>
            <v-card-title>{{ Titulo }}</v-card-title>
            <v-card-text>
             <p v-html="Texto"></p>
              <div v-if="videomodal !='' && videomodal != null" style="padding-top: 20px">
                <iframe  width="100%" height="315" :src="videomodal" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>

            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="modalEventos = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </section>
    <section class="section-padding" style="background: rgb(245 245 245);;padding: 30px;">
      <v-container>
        <div class="row">
          <div class="col-xl-12">
            <!-- Section Tittle -->
            <div class="section-tittle section-tittle6 mb-50">
              <div class="front-text">
                <h3 class="" style="color:#000000;">Confira como foram os Eventos</h3>
              </div>
            </div>
          </div>
        </div>
        <v-row justify="center">
          <v-col cols="12">
            <v-text-field v-model="searchQueryLast" label="Pesquisar" outlined clearable></v-text-field>
          </v-col>
        </v-row>
          <v-row justify="left">
            <v-col cols="12" sm="6" md="4" lg="4" v-for="menu in paginatedBlogsLast" :key="menu.itiId">
              <v-card class="mx-auto" max-width="400">
                    <router-link :to="'/EventosDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                    <v-img class="align-end text-white" height="200" :src="$imgURL + menu.insInstitucionalImagens[0].itgUrlImagem" cover>
                     </v-img>
                   

                    <v-card-subtitle class="pt-4">
                        {{ formattedDate(menu.itiData1) }}
                    </v-card-subtitle>

                    <v-card-text>
                      <h5>{{ menu.itiNome }}</h5>
                    <div>Local: {{ menu.itiCampoExtra1 }}</div>

                    <div style="height: 30px;">Duração: {{ menu.itiCampoExtra2 }}</div>
                    </v-card-text>
                  </router-link>
                    <v-card-actions>
                        <router-link :to="'/EventosDetalhe/' + menu.itiId + '/' + menu.itiNome.replaceAll(' ','-').replaceAll('/','').replaceAll(',','')" style="color:#443e40 !important">
                            Saiba mais
                        </router-link>
                    </v-card-actions>
                </v-card>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-pagination
              v-model="page"
              :length="totalPages"
              @input="changePage"
              prev-icon="mdi mdi-chevron-left"
              next-icon="mdi mdi-chevron-right"
            ></v-pagination>
          </v-row>
        </v-container>
    </section>
  </main>
</template>

<script>
import moment from 'moment'
import axios from 'axios';
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';

export default {
  name: 'TreinamentosEventosView',
  setup() {
    const route = useRoute();
    const id = route.params.idEvento;
    return {
      id
    };
  },
  components: {
  },
  data: () => ({
    blogtopo: [],
    blog: [],
    blogLast:[],
    newb: [],
    page: 1, // Página atual
    perPage: 6, // Número de itens por página
    searchQuery:'',
    pageLast: 1, // Página atual
    perPageLast: 12, // Número de itens por página
    searchQueryLast:'',
    modalEventos: false,
    Titulo:'',
    Texto:'',
    videomodal:'',
  }),
  computed: {
    totalPages() {
      return Math.ceil(parseInt(this.filteredBlogs.length) / this.perPage);
    },
    filteredBlogs() {
      if (this.searchQuery === '') {
        return this.blog;
      } else {
        return this.blog.filter(menu => {
          return menu.itiNome.toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      }
    },
    paginatedBlogs() {
      const start = (this.page - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredBlogs.slice(start, end);
    },
    totalPagesLast() {
      return Math.ceil(parseInt(this.filteredBlogsLast.length) / this.perPageLast);
    },
    filteredBlogsLast() {
      if (this.searchQueryLast === '') {
        return this.blogLast;
      } else {
        return this.blogLast.filter(menu => {
          return menu.itiNome.toLowerCase().includes(this.searchQueryLast.toLowerCase());
        });
      }
    },
    paginatedBlogsLast() {
      const startLast = (this.pageLast - 1) * this.perPageLast;
      const endLast = startLast + this.perPageLast;
      return this.filteredBlogsLast.slice(startLast, endLast);
    },
  },
  methods: {
    carregaMetas() {
      useHead({
        title: 'Treinamentos e Eventos - Seleto Industrial Máquinas para Industria Alimentícia'
      })
    },
    changePage(page) {
      this.page = page;
    },
    changePageLast(pagelast) {
      this.pageLast = pagelast;
    },
    formattedDate(value) {
      return this.$moment(value).format('DD/MM/YYYY')
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth" // Isso adicionará uma animação de rolagem suave
      });
    },
    isMobile() {
      return window.innerWidth <= 768; // Você pode ajustar esse valor de acordo com suas necessidades
    },
    OpenModal(menu){
      this.Titulo = menu.itiNome;
      this.Texto = menu.itiResumo1;
      this.videomodal = menu.itiReferencia;
      this.modalEventos = true;
    },
  },
  created() {
    this.carregaMetas();

    axios.get('/Process/InsInstitucional/institucional/32/treinamentostopo')
      .then(response => {
        this.blogtopo = response.data;
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/institucional/33/treinamentoseventos')
      .then(response => {
        this.blog = response.data.filter(x => x.itiVisivel && x.itiData1 >= this.$moment().format('YYYY-MM-DD')).sort((a, b) => a.itiData1 - b.itiData1).reverse();
        this.blogLast = response.data.filter(x => x.itiVisivel && x.itiData1 < this.$moment().format('YYYY-MM-DD')).sort((a, b) => a.itiData1 - b.itiData1).reverse();
        console.log('response.data')
        console.log(response.data)

      if (this.id !='' && this.id!=null){
        let result = this.blog.filter(x=> x.itiId == this.id)[0];
        this.OpenModal(result);
      }



      })
      .catch(error => {
        console.error(error);
      });

  


  },
}
</script>

<style>
.das {
  display: block !important;
}

.slider-text h2 p {
  font-size: 60px;
  color: #081624;
  padding: 10px;
  display: inline-block;
  background: #99CC33;
  line-height: 1;
}



</style>
